module.exports = __webpack_public_path__ + "img/3.b6e2b924.png";